module.exports = __webpack_public_path__ + "img/force1.5c4c4c35.png";